import Color from '../Color.js';

// simple Euclidean distance
export default function (a, b) {
  var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'lab';
  // Delta E (CIE 1976)
  // see http://www.brucelindbloom.com/index.html?Equations.html
  a = new Color(a);
  b = new Color(b);
  var l1 = a.get(mode);
  var l2 = b.get(mode);
  var sum_sq = 0;
  for (var i in l1) {
    var d = (l1[i] || 0) - (l2[i] || 0);
    sum_sq += d * d;
  }
  return Math.sqrt(sum_sq);
}